// @core/api/endpoints/team/get_team_security_settings.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetTeamSecuritySettingsResponse,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Get team security settings
 * Retrieves team security settings by the specified identifier.
 */
export async function GetTeamSecuritySettings(
  team_id: string,
  options?: RequestOptions
): Promise<GetTeamSecuritySettingsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/settings/security`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  const requestOptions = options;
  return client.get<GetTeamSecuritySettingsResponse>(requestPath, { ...requestOptions });
}
